module.exports = __webpack_public_path__ + "img/middle-1.a4099a56.png";